import "./AsignarCiclos.scss";
import { useQuery } from "@tanstack/react-query";
import { ComunicacionAjax } from "../../../ts/api/comunicacion";
import { Disclosure } from "../../../components/Disclosure";
import { ModalOrdenFabricacionListado } from "./components/ModalOrdenFabricacionListado";
import { ModalSeleccionarPersonal } from "./components/ModalSeleccionarPersonal";
import { ModalCicloNotificacion } from "./components/ModalCicloNotificacion";
import { FiltroCiclos } from "./components/FiltroCiclos";
import { useMemo, useState } from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { useDisclosureData } from "../../../hooks/UseDisclosure";
import { ModalCrearOF } from "../../../components/modals/CrearOF";
import { Loading, QueryError } from "../../../components/Loading/Loading";

export function AsignarCiclosPage() {
	const [newCiclosShown, setNewCiclosShown] = useState(false);
	const [filtroCiclo, setFiltroCiclo] = useState<string | null>(null);

	return (
		<div id="content" className="content" >
			<title>Almacen | Asignar Ciclos</title>
			<div>

				<Breadcrumb
					sectionTitle="Asignar Ciclos"
					links={[
						{ label: "Asignar Ciclos", active: true }
					]}
				/>


				<Disclosure style={{ marginBottom: 20 }}>
					{/* First element is the summary, second is the content */}
					<h4 className="panel-title panel-heading senalar">
						Filtro
					</h4>
					<FiltroCiclos filtroCiclo={filtroCiclo} setFiltroCiclo={setFiltroCiclo} />
				</Disclosure>


				<div className="table-responsive">
					<TablaCiclos filtroCiclo={filtroCiclo} />
				</div>
			</div>

			<ModalCicloNotificacion show={newCiclosShown} close={() => setNewCiclosShown(false)} />
		</div>
	);
}


function TablaCiclos(props: { readonly filtroCiclo: string | null; }) {
	// $(document).on("click", ".ordenesfabricacion", function () {
	// 	const xconjunto_id = String($(this).attr("xconjunto_id"));
	// 	void getOrdenesConjunto(xconjunto_id);
	// 	$("#modalOrdenFabricacionListado").modal("show");
	// });
	const discloseVerOrdenes = useDisclosureData<string | null>(null);
	const discloseCrearOrden = useDisclosureData<string | null>(null);
	const discloseSeleccionarPersonal = useDisclosureData<number | null>(null);

	const { data, error, isPending } = UseArticulosCiclos();
	const { data: dataAsignados, error: errorAsignados, isPending: isPendingAsignados } = UseCiclosAsignados();

	const ciclosVisualizados = useMemo(() => {
		if (data == null) return [];

		const ciclos = props.filtroCiclo ?
			Object.entries(data).filter(([idCiclo]) => idCiclo === props.filtroCiclo) :
			Object.entries(data);
		return ciclos.sort((a, b) => Number(a[0]) - Number(b[0]));
	}, [data, props.filtroCiclo]);

	if (error || errorAsignados) return <QueryError error={error ?? errorAsignados} fallback="Error al cargar los datos" />;
	if (isPending || isPendingAsignados) return <Loading />;

	return <>
		<table className="display dataTable" style={{ textAlign: "center" }}>
			<thead>
				<LineaHeader />
			</thead>
			<tbody>
				{ciclosVisualizados.map(([idCiclo, articulos]) => (
					<LineaCiclo
						key={idCiclo}
						idCiclo={idCiclo}
						articulos={articulos}
						isAsignado={dataAsignados.includes(Number(idCiclo))}
						openVerOrdenes={discloseVerOrdenes.open}
						openCrearOrden={discloseCrearOrden.open}
						openSeleccionarPersonal={discloseSeleccionarPersonal.open}
					/>
				))}
			</tbody>
		</table>
		<ModalOrdenFabricacionListado
			xconjunto_id={discloseVerOrdenes.data}
			show={discloseVerOrdenes.isOpen}
			close={discloseVerOrdenes.close}
		/>
		<ModalCrearOF
			idArticulo={discloseCrearOrden.data}
			show={discloseCrearOrden.isOpen}
			close={discloseCrearOrden.close}
		/>
		<ModalSeleccionarPersonal
			idCiclo={discloseSeleccionarPersonal.data}
			show={discloseSeleccionarPersonal.isOpen}
			close={discloseSeleccionarPersonal.close}
		/>
	</>;
}

function LineaHeader() {
	return (
		<tr>
			<th className="dt-center">Ciclo</th>

			<th className="dt-center md:hidden">Familia</th>
			<th className="dt-center md:hidden">SubFamilia</th>
			<th className="dt-center sm:hidden">Artículo</th>

			<th className="dt-center">Pedido</th>
			<th className="dt-center">Stock</th>

			<th className="dt-center lg:cell hidden sm:hidden">Min/Max</th>
			<th className="dt-center lg:hidden">Mínimo</th>
			<th className="dt-center lg:hidden">Máximo</th>

			<th className="dt-center lg:cell hidden">Pte. Ent/Sal</th>
			<th className="dt-center lg:hidden">Pte. Entrada</th>
			<th className="dt-center lg:hidden">Pte. Salida</th>
			<th className="dt-center">Fabricar</th>

			<th></th>
		</tr>
	);
}
interface LineaCicloProps {
	readonly idCiclo: string,
	readonly articulos: Record<string, ArticulosFabricaLinea>;
	readonly isAsignado: boolean;
	readonly openVerOrdenes: (idArticulo: string) => void;
	readonly openCrearOrden: (idArticulo: string) => void;
	readonly openSeleccionarPersonal: (idCiclo: number) => void;
}
function LineaCiclo(props: LineaCicloProps) {
	const { idCiclo, articulos, openVerOrdenes, openCrearOrden, openSeleccionarPersonal } = props;

	const icon = props.isAsignado ? "/img/icons/clipboard-user-clicked.svg" : "/img/icons/clipboard-user.svg";
	return <>
		<tr className="lineaCiclo">
			<td >{idCiclo}</td>
			<td className="sm:hidden"></td>
			<td className="md:hidden"></td>
			<td className="md:hidden"></td>

			<td colSpan={3}></td>

			<td className="lg:cell hidden sm:hidden"></td>
			<td className="lg:hidden"></td>
			<td className="lg:hidden"></td>

			<td className="lg:cell hidden"></td>
			<td className="lg:hidden"></td>
			<td className="lg:hidden"></td>

			<td>
				<button className="btnIcon" onClick={() => openSeleccionarPersonal(Number(idCiclo))} type="button">
					<img className="square35" src={icon} />
				</button>
			</td>
		</tr>
		{Object.values(articulos).map((linea) => (
			<LineaArticulo key={linea.idArticulo} linea={linea} openVerOrdenes={openVerOrdenes} openCrearOrden={openCrearOrden} />
		))}
	</>;
}
interface LineaArticuloProps { readonly linea: ArticulosFabricaLinea; readonly openVerOrdenes: (idArticulo: string) => void; readonly openCrearOrden: (idArticulo: string) => void; }
function LineaArticulo(props: LineaArticuloProps) {
	const { linea, openCrearOrden, openVerOrdenes } = props;
	const format = (num: number | null) => num != null ? Intl.NumberFormat("es-ES", { maximumFractionDigits: 2, minimumFractionDigits: 0 }).format(num) : "";

	return (
		<tr className="lineaArticulo">
			<td className="sm:hidden"></td>
			<td className="md:hidden">{linea.nombreFamilia}</td>
			<td className="md:hidden">{linea.nombreSubFamilia}</td>
			<td>{linea.idArticulo} - {linea.nombreArticulo}</td>

			<td>{format(linea.pedido)}</td>
			<td>{format(linea.stock)}</td>

			<td className="lg:cell hidden sm:hidden">{format(linea.min)}/{format(linea.max)}</td>
			<td className="lg:hidden">{format(linea.min)}</td>
			<td className="lg:hidden">{format(linea.max)}</td>


			<td className="lg:cell hidden">
				{linea.rutaArticulo != null && (
					<button className="link" onClick={() => openVerOrdenes(linea.idArticulo)} type="button">
						{format(linea.pendienteEntrada)}
					</button>
				)}
				{linea.rutaArticulo == null && format(linea.pendienteEntrada)}
				/
				{format(linea.pendienteSalida)}
			</td>
			<td className="lg:hidden">
				{linea.rutaArticulo != null && (
					<button className="link" onClick={() => openVerOrdenes(linea.idArticulo)} type="button">
						{format(linea.pendienteEntrada)}
					</button>
				)}
				{linea.rutaArticulo == null && format(linea.pendienteEntrada)}

			</td>
			<td className="lg:hidden">{format(linea.pendienteSalida)}</td>

			<td>{format(linea.entrarRecomendado)}</td>

			<td className="p-0 h-full">
				{linea.rutaArticulo != null && (
					<button className="clickable mostrarModalLanzarOF" type="button" onClick={() => openCrearOrden(linea.idArticulo)}>
						<i className="fa fa-plus" />
					</button>
				)}
			</td>
		</tr>
	);



}



function UseCiclosAsignados() {
	return useQuery<number[]>({
		queryKey: ["getCiclosAsignados"],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<number[]>("GET", "/getCiclosAsignados");
		},
	});
}
function UseArticulosCiclos() {
	return useQuery<Record<number, Record<string, ArticulosFabricaLinea>>>({
		queryKey: ["getArticulosCiclos"],
		queryFn: () => {
			return ComunicacionAjax.sendAjaxRequest<Record<number, Record<string, ArticulosFabricaLinea>>>("GET", "/getArticulosCiclos");
		},
	});
}
interface ArticulosFabricaLinea {
	idCiclo: string,
	idMedio: string,
	nombreMedio: string,
	idPedido: string,

	nombreFamilia: string | null,
	nombreSubFamilia: string | null,
	idArticulo: string,
	nombreArticulo: string,
	rutaArticulo: string | null,

	min: number | null,
	max: number | null,
	stock: number | null,
	pendienteEntrada: number | null,
	pendienteSalida: number | null,
	entrarRecomendado: number | null,
	pedido: number | null,
}
